import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const CartDrawer = ({ cartCount, setIsDrawerOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isAnimating, setIsAnimating] = useState(false);

  const onDrawerCloseClickHandler = () => {
    setIsAnimating(true);
    const timer = setTimeout(() => setIsDrawerOpen(false), 900);
    document.body.style.overflow = "";
    return () => clearTimeout(timer);
  };
  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 z-40
                      `}
        onClick={onDrawerCloseClickHandler}
      ></div>

      <div
        className={`fixed right-0 top-0 w-[calc(100vw-30px)] lg:w-[612px] h-full bg-primary-bg-blue/80 text-primary-light shadow-lg z-50 ${
          isAnimating ? "animate-slideOutRight" : "animate-slideInRight"
        }`}
        style={{ animationDuration: `1s` }}
      >
        <div className="p-4 flex justify-between items-center ">
          <div className="container mx-auto py-4 flex items-center justify-end gap-4">
            {/* <p className="flex items-center justify-start gap-2 text-lg font-semibold">
              <span className="font-bold">
                დამატებულია {cartCount} პროდუქტი
              </span>
            </p> */}
            <button
              onClick={onDrawerCloseClickHandler}
              className="text-lg font-extrabold tracking-wider text-primary-orange"
            >
              დახურვა
            </button>
          </div>
        </div>
        <ul className="py-6 ox-4 flex flex-col items-center justify-center gap-8 list-none">
          <li
            className="relative py-4 group w-full flex items-center justify-center bg-primary-bg-blue/95"
            onClick={() => {
              onDrawerCloseClickHandler();

              delayNavigation(dispatch, navigate, `/`);
            }}
          >
            <span className="absolute -top-2 left-0 h-[1px] bg-primary-light w-full"></span>
            <Link>მთავარი გვერდი</Link>
            <span className="absolute -bottom-2 left-0 h-[1px] bg-primary-light w-full"></span>
          </li>

          <li
            className="relative py-4 group w-full flex items-center justify-center bg-primary-bg-blue/95"
            onClick={() => {
              onDrawerCloseClickHandler();
              delayNavigation(dispatch, navigate, `/about`);
            }}
          >
            <span className="absolute -top-2 left-0 h-[1px] bg-primary-light w-full"></span>
            <Link>K2 Invest</Link>
            <span className="absolute -bottom-2 left-0 h-[1px] bg-primary-light w-full"></span>
          </li>
          {/* <li
            className="relative py-4 group w-full flex items-center justify-center bg-primary-bg-blue/95"
            onClick={() => {
              onDrawerCloseClickHandler();
              delayNavigation(dispatch, navigate, `/company-view`)
              navigate("/company-view");
            }}
          >
            <span className="absolute -top-2 left-0 h-[1px] bg-primary-light w-full"></span>
            <Link>K2 ხედვა</Link>
            <span className="absolute -bottom-2 left-0 h-[1px] bg-primary-light w-full"></span>
          </li> */}
          <li
            className="relative py-4 group w-full flex items-center justify-center bg-primary-bg-blue/95"
            onClick={() => {
              onDrawerCloseClickHandler();
              delayNavigation(dispatch, navigate, `/projects`);
            }}
          >
            <span className="absolute -top-2 left-0 h-[1px] bg-primary-light w-full"></span>
            <Link>პროექტები</Link>
            <span className="absolute -bottom-2 left-0 h-[1px] bg-primary-light w-full"></span>
          </li>
          <li
            className="relative py-4 group w-full flex items-center justify-center bg-primary-bg-blue/95"
            onClick={() => {
              onDrawerCloseClickHandler();
              delayNavigation(dispatch, navigate, `/news`);
            }}
          >
            <span className="absolute -top-2 left-0 h-[1px] bg-primary-light w-full"></span>
            <Link>სიახლეები</Link>
            <span className="absolute -bottom-2 left-0 h-[1px] bg-primary-light w-full"></span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default CartDrawer;
